package co.torvus.web.components

import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h2
import react.dom.html.ReactHTML.img
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.span
import web.cssom.ClassName

private external interface StoreBadgeProps : Props {
    var icon: String
    var small: String
    var big: String
}

private val StoreBadge = FC<StoreBadgeProps> { props ->
    div {
        className = ClassName("store-badge")
        img {
            className = ClassName("store-badge-icon")
            src = props.icon
            alt = ""
        }
        div {
            className = ClassName("store-badge-text")
            span {
                className = ClassName("store-badge-small")
                +props.small
            }
            span {
                className = ClassName("store-badge-big")
                +props.big
            }
        }
    }
}

val DownloadBadges = FC<Props> {
    div {
        className = ClassName("home-download")
        h2 {
            className = ClassName("home-download-title")
            +"Coming soon to mobile"
        }
        div {
            className = ClassName("store-badges")
            StoreBadge {
                icon = "icons/play.svg"
                small = "GET IT ON"
                big = "Google Play"
            }
            StoreBadge {
                icon = "icons/apple.svg"
                small = "Download on the"
                big = "App Store"
            }
        }
        p {
            className = ClassName("alpha-note")
            +"Torvus is still in alpha testing and will become available in production soon."
        }
    }
}
